import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = ({ size = "medium", color = "#00c853" }) => {
  return (
    <div
      className={`loading-spinner ${size}`}
      style={{ "--spinner-color": color }}
    >
      <div className="spinner"></div>
    </div>
  );
};

export default LoadingSpinner;
